import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import ptLocale from '@fullcalendar/core/locales/pt';
import frLocale from '@fullcalendar/core/locales/fr';
import ajax from './ajax';
import { addDays, addHours, endOfDay, format, parseISO, startOfDay } from 'date-fns';

let calendarLocale;
switch (window.dateLocale.code) {
    case 'pt':
        calendarLocale = ptLocale;
        break;
    case 'fr':
        calendarLocale = frLocale;
        break;
}

document.querySelectorAll('[data-professional-calendar]').forEach((el) => {
    const professionalId = el.getAttribute('data-professional-calendar');

    const fetchedDates = [];
    const calendar = new Calendar(el, {
        locale: calendarLocale,
        plugins: [timeGridPlugin],
        initialView: 'timeGridWeek',
        slotDuration: '01:00:00',
        height: '100%',
        contentHeight: 1000,
        expandRows: true,
        allDaySlot: false,
        scrollTime: '08:00:00',
        slotLabelFormat: {
            hour: 'numeric',
            minute: 'numeric',
        },
        dayHeaderFormat: {
            weekday: 'short',
            day: 'numeric',
            month: 'numeric',
            omitCommas: true,
        },
        eventTimeFormat: () => '',
        datesSet: ({ start, end }) => {
            if (fetchedDates.includes(start.toISOString())) return;

            let dateIterator = new Date(start);

            while (dateIterator < end) {
                const dateString = format(dateIterator, 'yyyy-MM-dd');

                ajax.get(`professionals/${professionalId}/availability`, {
                    params: {
                        from: startOfDay(dateIterator).toISOString(),
                    },
                }).then(({ data }) => {
                    data.forEach(({ start, end }) => {
                        start = parseISO(start);
                        end = parseISO(end);
                        calendar.addEvent({ start, end, className: 'slot', display: 'background' });
                    });
                });

                ajax.get(`appointments`, {
                    params: {
                        professional_id: professionalId,
                        date: dateString,
                    },
                }).then(({ data }) => {
                    data.forEach(({ date, patient, id }) => {
                        const start = parseISO(date);
                        const end = addHours(start, 1);
                        calendar.addEvent({ start, end, className: 'appointment', title: `<a href="/admin/appointments/${id}">${format(start, 'HH:mm')} - ${patient.name}</a>` });
                    });
                });

                dateIterator = addDays(dateIterator, 1);
            }

            fetchedDates.push(start.toISOString());
        },
        eventContent: ({ event }) => {
            if (event.display != 'background' && event.classNames[0] == 'appointment') {
                return { html: event.title };
            }
        },
    });

    calendar.render();
});
